import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarOutlinedSize48Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24 0c6 9 15 18 24 24-9 6-18 15-24 24-6-9-15-18-24-24C9 18 18 9 24 0m0 6.172C19.004 12.713 12.713 19.004 6.172 24 12.712 28.996 19.004 35.285 24 41.826c4.996-6.54 11.286-12.83 17.826-17.826C35.286 19.004 28.996 12.713 24 6.172"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HyperstarOutlinedSize48Glyph.displayName = 'HyperstarOutlinedSize48Glyph';
